import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  DefualtBannerContent = [
    {
      image: '../../../assets/images/carousel-2.png',
      title:'Horse Racing',
      content:'Uk / Australia / France / German Racing'
    }
  ];

  getDefaultBanner(){
    return this.DefualtBannerContent;
  }
}
